// extracted by mini-css-extract-plugin
export var container = "Legals-module--container--9ed9c";
export var richText = "Legals-module--richText--79b4b";
export var section = "Legals-module--section--dbfbe";